import { render } from "./MenuPatientList.vue?vue&type=template&id=633922d0&scoped=true"
import script from "./MenuPatientList.vue?vue&type=script&lang=js"
export * from "./MenuPatientList.vue?vue&type=script&lang=js"

import "./MenuPatientList.vue?vue&type=style&index=0&id=633922d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633922d0"]])

export default __exports__